import capitalize from 'lodash/capitalize';

const WORKFLOW_TYPE_LABELS: Record<
  string,
  { singular: string; plural: string }
> = {
  abtest: { singular: 'A/B test', plural: 'A/B tests' },
  'c4s-ab-test': { singular: 'A/B test', plural: 'A/B tests' },
  rollout: { singular: 'rollout', plural: 'rollouts' },
  'c4s-rollout': { singular: 'rollout', plural: 'rollouts' },
  analysis: { singular: 'analysis', plural: 'analyses' },
  reanalysis: { singular: 'analysis', plural: 'analyses' },
  'spotify-analysis': { singular: 'analysis', plural: 'analyses' },
  'static-config': { singular: 'static config', plural: 'static configs' },
};

export const WORKFLOW_TYPE_IDS: readonly string[] =
  Object.keys(WORKFLOW_TYPE_LABELS);

export type WorkflowDisplayNameFormatOptions = {
  capitalize?: boolean;
  pluralize?: boolean;
};

export const formatWorkflowDisplayName = (
  workflowId: string,
  options: WorkflowDisplayNameFormatOptions = {},
): string => {
  const { capitalize: shouldCapitalize, pluralize } = options;
  const labels = WORKFLOW_TYPE_LABELS[workflowId];
  let label = workflowId;

  if (labels) {
    label = pluralize ? labels.plural : labels.singular;
  }

  return shouldCapitalize && !/[A-Z]/.test(label) ? capitalize(label) : label;
};

export const useFormatWorkflowDisplayName = () => formatWorkflowDisplayName;
